import { QueryClient } from '@tanstack/react-query';

/**
 * 전역 단일 QueryClient.
 * - staleTime: 30초 — 같은 쿼리 즉시 재호출 시 캐시 사용
 * - gcTime: 5분 — 사용 안 하는 쿼리 캐시 보존 시간
 * - retry: 1 — 네트워크 오류 시 1회만 재시도 (boilerplate 방지)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
